import { driver } from 'driver.js';
import 'driver.js/dist/driver.css';
import { markOnboardingSeen } from '../lib/api';

const STEPS = [
  {
    el: '[data-testid="home-greeting"]',
    title: 'Welcome to Guest Checkout 👋',
    desc: 'A quick tour of the essentials — about 20 seconds.',
    side: 'bottom',
    align: 'start',
  },
  {
    el: '[data-testid="daily-activity-heading"]',
    title: 'Daily activity',
    desc: 'Every check-out, cleaning and ready property for any day, at a glance.',
    side: 'bottom',
    align: 'start',
  },
  {
    el: '[data-testid="stat-cleaning"]',
    title: 'Live status',
    desc: 'How many properties are checked out, being cleaned or ready — in real time.',
    side: 'bottom',
    align: 'center',
  },
  {
    el: '[data-tour="nav-properties"]',
    title: 'Properties & QR codes',
    desc: 'Add properties, customise checkout instructions, and share the QR, printable card or link with guests.',
    side: 'top',
    align: 'center',
  },
  {
    el: '[data-tour="nav-checkouts"]',
    title: 'Checkouts',
    desc: 'Track every guest checkout, export reports and schedule future late checkouts.',
    side: 'top',
    align: 'center',
  },
  {
    el: '[data-tour="nav-team"]',
    title: 'Your team',
    desc: 'Add cleaners, staff and cleaning companies so they get instant checkout alerts.',
    side: 'top',
    align: 'center',
  },
  {
    el: '[data-tour="nav-settings"]',
    title: 'Plan & account',
    desc: 'Manage your subscription, notifications and account settings here.',
    side: 'top',
    align: 'center',
  },
];

export function runOnboardingTour(onComplete) {
  const steps = STEPS.filter((s) => document.querySelector(s.el)).map((s) => ({
    element: s.el,
    popover: { title: s.title, description: s.desc, side: s.side, align: s.align },
  }));

  let done = false;
  const finish = () => {
    if (done) return;
    done = true;
    markOnboardingSeen().catch(() => {});
    if (onComplete) onComplete();
  };

  if (steps.length === 0) {
    finish();
    return;
  }

  const d = driver({
    showProgress: true,
    allowClose: true,
    overlayColor: 'rgba(15, 23, 42, 0.75)',
    stagePadding: 6,
    stageRadius: 12,
    popoverClass: 'gc-tour',
    nextBtnText: 'Next →',
    prevBtnText: '← Back',
    doneBtnText: 'Got it 🎉',
    progressText: '{{current}} of {{total}}',
    steps,
    onDestroyed: finish,
  });
  d.drive();
}
